import { BaseComponent } from '../../components/base-component'
import type { CartPage } from './cart'
import type { CartDrawer } from '../cart-drawer/cart-drawer'
import { $el, $elParent, whenDefined } from 'src/scripts/utils/utils'

const TEXTAREA_SELECTOR = '[data-cart-note-textarea]'
const LOCAL_STORAGE_SELECTOR = 'cartNote'
const CART_SELECTOR = 'cart-page'
const CART_DRAWER_SELECTOR = 'cart-drawer'

export class CartNote extends BaseComponent {
  valueFromLS: string | null
  currentValue: string | undefined

  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    const cart: CartPage = $elParent(CART_SELECTOR, this)
    const textarea: HTMLTextAreaElement = $el(TEXTAREA_SELECTOR, this)
    this.currentValue = textarea?.value

    this.updateByLocalStorage()
    this.addListener(textarea, 'blur', this.handleTextareaBlur)
    this.addListener(window, 'storage', this.handleBetweenTabsUpdate)
    whenDefined(CART_SELECTOR).then(() =>
      cart?.on('cartIsEmpty', this.handleCartStatusUpdate),
    )
    whenDefined(CART_DRAWER_SELECTOR).then(() =>
      cartDrawer?.on('cartIsEmpty', this.handleCartStatusUpdate),
    )
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    const cart: CartPage = $elParent(CART_SELECTOR, this)

    whenDefined(CART_SELECTOR).then(() =>
      cart?.off('cartIsEmpty', this.handleCartStatusUpdate),
    )
    whenDefined(CART_DRAWER_SELECTOR).then(() =>
      cartDrawer?.off('cartIsEmpty', this.handleCartStatusUpdate),
    )
  }

  handleTextareaBlur = (event: FocusEvent): void => {
    const { value } = event.target as HTMLInputElement

    if (!value) {
      return
    }

    localStorage.setItem(LOCAL_STORAGE_SELECTOR, value)
    this.currentValue = value
  }

  updateByLocalStorage = (): void => {
    const textarea: HTMLTextAreaElement = $el(TEXTAREA_SELECTOR, this)
    this.valueFromLS = localStorage.getItem(LOCAL_STORAGE_SELECTOR)

    if (this.valueFromLS !== this.currentValue) {
      textarea.value = this.valueFromLS
      this.currentValue = this.valueFromLS
    }
  }

  handleBetweenTabsUpdate = (event: StorageEvent): void => {
    if (event.key === LOCAL_STORAGE_SELECTOR) {
      this.updateByLocalStorage()
    }
  }

  handleCartStatusUpdate = (): void => {
    this.clearValueFromLS()
  }

  clearValueFromLS = (): void => {
    localStorage.removeItem(LOCAL_STORAGE_SELECTOR)
    this.currentValue = undefined
  }
}
